require('../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../ComponentSet";

// -----------------
// ---------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet
}).$mount('#app');